import type { HelpTurn } from "./chatTypes";

export const codepoints = (text: string) => Array.from(text).length;
export const cleanInput = (text: string) => text.replace(/[\x00-\x08\x0b\x0c\x0e-\x1f\x7f]/g, ""); // eslint-disable-line no-control-regex
export const redactEmail = (text: string) => text.replace(/[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+/g, "(メールアドレス)");
export function trimHistory(turns: HelpTurn[]) {
  const history = turns.map((t) => ({ ...t, text: redactEmail(cleanInput(t.text)) }));
  let trimmed = false;
  while (history.length > 12 || history.reduce((n, t) => n + codepoints(t.text), 0) > 16000) {
    history.splice(0, 2); trimmed = true;
  }
  return { history, trimmed };
}
